import React, { useState } from 'react';
import {
  BOARD_LANGUAGES,
  type AdminBoardEditorialDto,
  type AdminBoardWorkDto,
  type LocalizedText,
} from '@living-library/contracts';
import { c, card } from './board-ui';

export function BoardPreview({
  item,
  works,
}: {
  item: AdminBoardEditorialDto;
  works: Record<string, AdminBoardWorkDto>;
}) {
  const [language, setLanguage] = useState<keyof LocalizedText>('sk');
  const groups =
    item.kind === 'quiz'
      ? item.questions.map((question) => ({
          id: question.id,
          title: question.prompt[language],
          works: question.options.map((option) => option.workId),
        }))
      : [{ id: item.id, title: item.period, works: item.items.map((pick) => pick.workId) }];
  return (
    <section className={`${card} mt-6`}>
      <h2 className="font-serif text-2xl">{c.preview}</h2>
      <div className="admin-tabs my-5 w-fit" aria-label={c.preview}>
        {BOARD_LANGUAGES.map((value) => (
          <button
            type="button"
            key={value}
            aria-pressed={language === value}
            onClick={() => setLanguage(value)}
          >
            {value.toUpperCase()}
          </button>
        ))}
      </div>
      {item.kind === 'quiz' && (
        <>
          <h3 className="font-serif text-2xl">{item.title[language] || '—'}</h3>
          <p className="mt-2 whitespace-pre-wrap text-ink-soft">{item.intro[language] || '—'}</p>
        </>
      )}
      {groups.map((group) => (
        <div key={group.id} className="mt-6 border-t border-line/65 pt-5">
          <h4 className="mb-4 font-semibold">{group.title || '—'}</h4>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {group.works.map((id, index) => {
              const book = works[id]?.editions[language];
              return (
                <article key={`${id}-${index}`} className="min-w-0 rounded-xl bg-panel-raised p-3">
                  {book?.coverImageUrl ? (
                    <img
                      className="mb-3 h-36 w-full object-contain object-left"
                      src={book.coverImageUrl}
                      alt={book.title}
                    />
                  ) : (
                    <div className="mb-3 flex h-36 items-center rounded border border-line/40 p-3 text-sm text-warning">
                      {book ? book.title : `${c.editionMissing} ${language.toUpperCase()}`}
                    </div>
                  )}
                  <p className="text-sm font-semibold">{book?.title ?? '—'}</p>
                  <p className="text-xs text-ink-muted">{book?.authors.join(', ')}</p>
                  {item.kind === 'picks' && (
                    <p className="mt-2 text-sm">{item.items[index]?.reason[language] || '—'}</p>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
